export default "__VITE_ASSET__1e48cb8e__"